export const { BASE_URL, API_URL, SOCKET_URL, SUBTITLES_API_URL, ROUTER_ROOT, PUBLIC_URL_ROOT } = process.env;

export const { SENTRY_DSN } = process.env;

export const ENABLE_SENTRY = process.env.ENABLE_SENTRY === 'true';

export const isProduction = process.env.NODE_ENV === 'production';
export const isDebugEnabled = process.env.DEBUG === 'true';

let localFromUrl = window.location.pathname.split('/')[1];

if(localFromUrl.length !== 2) {
  localFromUrl = ''
}else{
  localFromUrl = "/" + localFromUrl.toLowerCase();
}

export const LOCALE = localFromUrl;

// add window properties

//@ts-ignore
window.LOCALE = window.LOCALE || LOCALE;

//@ts-ignore
window.BASE_URL = window.BASE_URL || BASE_URL;
//@ts-ignore
window.SUBTITLES_API_URL = window.SUBTITLES_API_URL || SUBTITLES_API_URL;

